import { createApp } from "vue";
import App from "./App.vue";
import joint from "@/plugins/joint/index";
import antdImport from "./antdImport";

if (process.env.NODE_ENV === "development") {
  // @import "~ant-design-vue/dist/antd.less";
  // @import "./theme.less";
  // import "~ant-design-vue/dist/antd.less";
  // import "./theme.less";
  // import("./theme.less").then((style) => {
  //   style.use();
  //   console.log("./theme.less", style);
  // });
}

const app = createApp(App);

app.use(joint);
antdImport(app);

app.mount("#app");
